import { render } from "./IronBullRoll.vue?vue&type=template&id=12336ede&scoped=true"
import script from "./IronBullRoll.vue?vue&type=script&lang=js"
export * from "./IronBullRoll.vue?vue&type=script&lang=js"

import "./IronBullRoll.vue?vue&type=style&index=0&id=12336ede&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12336ede"]])

export default __exports__